
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"60","height":"60"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"none","stroke":"#241f21","stroke-miterlimit":"10","stroke-width":"2","d":"M30 0v8.07M49.9 36.26H10.11L6.13 29.4h47.74l-3.97 6.86zM23.18 14.91l-3.82-6.5h21.28l-3.83 6.5"}}),_c('path',{attrs:{"d":"M37.38 60v-5.89c0-3.37 3.93-18 3.93-18M22.62 60v-5.89c0-3.37-3.93-18-3.93-18M10.39 29.33l-8.89-8.1 2.78-6.54s51.31-.18 51.44 0l2.78 6.54-8.89 8.1M1.78 21.23h56.44M30 36.7V60","fill":"none","stroke":"#241f21","stroke-miterlimit":"10","stroke-width":"2"}})])
          )
        }
      }
    